import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { Header } from 'components';

@withRouter
@inject(rootStore => ({
    authStore: rootStore.authStore,
    appStore: rootStore.appStore
}))
@observer
class MainLayout extends React.Component {
    constructor(props) {
        super(props);
        this.handleLogout = this.handleLogout.bind(this);
    }

    render() {
        const { error } = this.props.appStore;
        const { user } = this.props.authStore;
        return (
            <div>
                <Header onLogout={this.handleLogout} username={user.username} />
                {error !== null ? <div style={{ backgroundColor: 'yellow' }}>{error}</div> : null}
                <main className="padd--pull--med padd--push--med spc--top--lrg">
                    {this.props.children}
                </main>
                <footer>
                </footer>
            </div>
        )
    }

    async handleLogout(e) {
        e.preventDefault();
        await this.props.authStore.removeSession();
    }
}

export { MainLayout }


// WEBPACK FOOTER //
// ./src/layouts/MainLayout.js